function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.6999 4.30003C18.0899 4.69003 18.0899 5.32003 17.6999 5.71003L14.9999 8.41003L13.5899 7.00003L16.2899 4.30003C16.6799 3.91003 17.3199 3.91003 17.6999 4.30003Z",
  fill: "#727981"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9999 10.41L6.28994 5.71003C5.89994 5.32003 5.89994 4.69003 6.28994 4.30003C6.67994 3.91003 7.30994 3.91003 7.69994 4.30003L12.4099 9.00003C12.7899 9.38003 12.9999 9.88003 12.9999 10.41L13 12.4999H11L10.9999 10.41Z",
  fill: "#727981"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12 11C9.24 11 7 13.24 7 16C7 18.76 9.24 21 12 21C14.76 21 17 18.76 17 16C17 13.24 14.76 11 12 11ZM14 16.5H12.5V18C12.5 18.275 12.275 18.5 12 18.5C11.725 18.5 11.5 18.275 11.5 18V16.5H10C9.725 16.5 9.5 16.275 9.5 16C9.5 15.725 9.725 15.5 10 15.5H11.5V14C11.5 13.725 11.725 13.5 12 13.5C12.275 13.5 12.5 13.725 12.5 14V15.5H14C14.275 15.5 14.5 15.725 14.5 16C14.5 16.275 14.275 16.5 14 16.5Z",
  fill: "#727981"
});

function SvgMergeIconWithCreating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeIconWithCreating);
export default __webpack_public_path__ + "static/media/merge_icon_with_creating.21c92103.svg";
export { ForwardRef as ReactComponent };